import Link from 'next/link'
import { Card, CardBody } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'

function VoiceAuth () {
  const breadcrumbs = [
    { name: 'Login Help', href: '/login-help' },
    { name: 'Voice Call Authentication', href: '/login-help/voice-call-auth' }
  ]

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />

      <h2 className='pb-2'>Voice Call Authentication</h2>

      <Card>
        <CardBody>
          <p>
            Voice Call Authentication allows you to receive an authentication code through an automated voice call.
          </p>
          <p>
            In order to use voice call authentication, you must first set up either <Link href='/login-help/okta-verify'><a>Okta Verify</a></Link> or <Link href='/login-help/sms-auth'><a>SMS Authentication</a></Link>. Voice call authentication can then be enabled when you first log in.
          </p>
          <p>
            Please note that this authentication method should only be used with your personal mobile phone number. <b>It is not recommended</b> to use a landline or phone number that multiple people have access to.
          </p>
          <hr />
          <h2>Setting up Voice Call Authentication</h2>
          <p>
            After logging in for the first time, go to <a href='https://schumacher.okta.com'>schumacher.okta.com</a>. Click your name in the upper righthand corner, then click <b>Settings</b> in the dropdown menu.
          </p>
          <img className='mb-4' src='/static/img/okta-settings-dropdown.png' alt='okta settings' />
          <p>
            On the Settings page, scroll to the <b>Extra Verification</b> section, and then click the <b>Set up</b> button next to Voice Call Authentication.
          </p>
          <img className='mb-4' src='/static/img/voice-call-setup.png' alt='voice call authentication setup' />
          <br />
          <p>
            The next screen will ask you to enter your mobile number.
            Select your country, then enter your mobile number and press <b>Call</b>.
          </p>
          <img className='mb-4' src='/static/img/voice-call-auth.png' alt='voice call authentication' />
          <p>
            You should receive a phone call on your mobile device.
            Enter the code from the automated message into the verification box and press <b>Verify</b>.
          </p>
          <p>
            The settings page should now show Voice Call Authentication as Enabled in the Extra Verification section.
          </p>
        </CardBody>
      </Card>
    </>
  )
}

VoiceAuth.publicAccess = true

VoiceAuth.getInitialProps = () => ({
  title: 'Voice Call Authentication'
})

export default VoiceAuth
